import { NotificationsTypes } from '@/constants/notificationsTypes';

export class Notification {
    id;
    message;
    type;

    constructor(message = '', type = NotificationsTypes.SUCCESS, timer = type.timer) {
        this.message = message;
        this.type = type;
        this.id = Notification.count++;
        this.timer = timer;
    }

    static count = 0;
}


// WEBPACK FOOTER //
// ./src/utils/notifications.js